import { ReactNode } from "react";

import Callout from "@components/callout/callout";

const ProfileEmptyState = ({ children }: { children: ReactNode | string }) => {
  return (
    <Callout theme="default" center>
      {children}
    </Callout>
  );
};

export default ProfileEmptyState;
